import { render, staticRenderFns } from "./IssueDate.vue?vue&type=template&id=73247470&"
import script from "./IssueDate.vue?vue&type=script&lang=js&"
export * from "./IssueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports